<div class="dialog">
  <!-- close button -->
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" (click)="onClose()">close</mat-icon>
  <!-- title -->
  <div mat-dialog-title>
    <h3>{{ wizardTitle | xTranslate | uppercase }}</h3>
  </div>

  <p class="subtitle" *ngIf="wizardSubTitle">
    {{ wizardSubTitle | xTranslate }}
  </p>

  <!-- boby -->
  <div mat-dialog-content>
    <div class="wizard">
      <div class="steps-set" [ngClass]="isCustomSteps ? 'custom-tabs' : 'orange-tabs'">
        <ng-container *ngIf="wizardDriverService.currentStep$ | async as currentStep">
          <mat-tab-group [selectedIndex]="currentStep.stepNumber - 1" (selectedIndexChange)="loadStepByIndex($event)">
            <mat-tab
              *ngFor="let tab of stepTabs; let tabIndex = index; last as last"
              [disabled]="tab.step.stepNumber > currentStep.stepNumber && !stepReady"
              [ngClass]="{
                disabled: tab.step.stepNumber > currentStep.stepNumber && !stepReady,
                last: last,
              }"
            >
              <ng-template mat-tab-label>
                {{ tab.step.name | xTranslate }}
                <ng-container *ngIf="!isCustomSteps && !last">
                  <mat-icon svgIcon="arrow-front"></mat-icon>
                </ng-container>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </ng-container>
      </div>
      <!-- STEP PROJECTOR -->
      <div class="projection">
        <ng-template miqWizardProjector></ng-template>
      </div>
    </div>
  </div>

  <!-- global actions -->
  <div mat-dialog-actions>
    <div class="dialog__selections" *ngIf="actionSlots.length">
      <ng-container *ngIf="wizardDriverService.data$ | async as wizardData">
        <div class="dialog__selection-slot" *ngFor="let slot of actionSlots">
          <span class="dialog__selection-slot-label">{{ slot.label | xTranslate }}</span>
          <ng-container *ngIf="wizardData | wizardSlotSelection: slot as selection; else emptySlot">
            <div class="dialog__selection-slot-selected">
              <!-- dynamic component template -->
              <ng-container *ngIf="slot.componentType; else defaultSlotContent">
                <ng-container
                  *ngComponentOutlet="
                    slot.componentType;
                    inputs: { data: wizardData, entity: slot.inputs?.entity || [] }
                  "
                ></ng-container>
              </ng-container>

              <!-- default data-driven template -->
              <ng-template #defaultSlotContent>
                <div class="dialog__selection-slot-id-row">
                  <span class="dialog__selection-slot-id">{{ selection.id }}</span>
                  <span *ngIf="selection.idLabel" class="dialog__selection-slot-id-label">
                    {{ selection.idLabel }}</span
                  >
                </div>
                <div class="dialog__selection-slot-line" *ngFor="let line of selection.lines">{{ line }}</div>
              </ng-template>

              <button class="dialog__selection-slot-clear" (click)="clearSlot(slot)" type="button">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </ng-container>
          <ng-template #emptySlot>
            <span class="dialog__selection-slot-empty">{{ slot.emptyLabel | xTranslate }}</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
    <div class="footer-actions">
      <button
        mat-button
        color="primary"
        class="fx--mr-sm"
        *ngIf="!isFirst && !hideBackButton"
        (click)="prev()"
        l10nTranslate
      >
        recordsSearch.back
      </button>

      <button mat-button color="primary" class="fx--mr-sm" miqGoBackLink *ngIf="showStopButton">
        {{ 'recordsSearch.dontCreate' | xTranslate }}
      </button>

      <button
        mat-flat-button
        color="primary"
        class="fx--mr-sm"
        *ngIf="isLast; else backNextButtons"
        [disabled]="!stepReady"
        (click)="next()"
        l10nTranslate
      >
        {{ lastButtonText }}
      </button>
      <ng-template #backNextButtons>
        <button mat-flat-button color="primary" type="submit" [disabled]="!stepReady" (click)="next()" l10nTranslate>
          recordsSearch.next
        </button>
      </ng-template>
    </div>
  </div>
</div>
